import { Component, DestroyRef, inject, ChangeDetectorRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SharedService } from '../shared/services/shared.service';
import { Buyer4473Component } from '../form-4473/buyer-4473/buyer-4473.component';
import { Subscription } from 'rxjs';
import { ModalID } from '../shared/models/constants';

@Component({
    selector: 'app-kiosk',
    templateUrl: './kiosk.component.html',
    styleUrl: './kiosk.component.scss',
    standalone: true,
    imports: [Buyer4473Component]
})
export class KioskComponent {
private destroyRef = inject(DestroyRef);
  subscriptions = new Subscription();
  kiosk_selection: 'recert' | 'fill_out_form_4473'
  constructor(
    public sharedService: SharedService,
    private cdr: ChangeDetectorRef
  ) {
// kiosk_selection_made
      this.subscriptions.add(
            this.sharedService.kiosk_selection_made$
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe((response) => {
                if (response === 'fill_out_form_4473') {
                  this.sharedService.closeModal(ModalID.kiosk_selection);
                  this.kiosk_selection = 'fill_out_form_4473';
                  this.cdr.detectChanges();
                }
                
              })
          );
  }

   ngOnInit() {
    this.sharedService.openKioskSelection();
  }

}
